import { useState } from "react";
import type { CSSProperties, InputHTMLAttributes } from "react";

/** lucide非採用のため目アイコンはSVG直書き（ダーク背景のログイン画面向け配色） */
const EyeIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
    <line x1="2" x2="22" y1="2" y2="22" />
  </svg>
);

/**
 * 目のアイコンで表示/非表示を切り替えられるパスワード入力。
 * type 以外の input 属性はそのまま透過する。
 * style の margin / width はラッパー側へ移す（アイコンの縦位置を入力欄に合わせるため）。
 */
export default function PasswordInput({ style, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const [show, setShow] = useState(false);
  const { margin, marginTop, marginRight, marginBottom, marginLeft, width, ...inputStyle } =
    (style ?? {}) as CSSProperties;
  return (
    <div style={{ position: "relative", margin, marginTop, marginRight, marginBottom, marginLeft, width: width ?? "100%" }}>
      <input
        {...props}
        type={show ? "text" : "password"}
        style={{ width: "100%", boxSizing: "border-box", ...inputStyle, paddingRight: 44 }}
      />
      <button
        type="button" tabIndex={-1} onClick={() => setShow(s => !s)}
        aria-label={show ? "パスワードを隠す" : "パスワードを表示"}
        style={{
          position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
          background: "none", border: "none", cursor: "pointer",
          color: "rgba(255,255,255,0.55)", padding: 2, display: "flex", alignItems: "center",
        }}
      >
        {show ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}
